const toPositiveInt = (value: number) => (value >>> 0);

export const getDeterministicColor = (input: string): string => {
    // FNV-1a 32-bit hash for stable string hashing
    let hash = 0x811c9dc5;
    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i);
        hash = toPositiveInt(hash * 0x01000193);
    }

    // Use hash to generate visually distinct HSL values for dark backgrounds
    const hue = hash % 360;
    const saturation = 70 + (hash % 8); // 70-77%
    const lightness = 56 + (hash % 10); // 56-65%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
